import React from "react";
import './piedPage.css'
export const PiedPage = () => {
 return (
  <div className="piedDroit">
 <p className="piedPage ">
  © {new Date().getFullYear()}{" "}
  <a className="text" href="https://gexpertise.fr/"  target="_blank" >Gexpertise</a> - Tous droits réservés 
           </p>
  </div>
 

  )
};
